

<!--项目节点状态  -->
<template>
    <div v-if="initDataFlag">
        <span class="el-link-span-css">当前节点核验：</span>
        <!-- <el-link type="warning" v-if="model.approveStatus == 'COMMITTED'"  icon="el-icon-share">待核验</el-link>
        <el-link type="success" v-if="model.approveStatus == 'PASSED'" icon="el-icon-check">通过</el-link>
        <el-link type="danger" v-if="model.approveStatus == 'NOPASSED'" icon="el-icon-close">不通过</el-link> -->
        <!--因为平台没有处理好，所以暂时用中文进行判断  -->
        <el-link type="warning" class="el-link-css" :underline="false" v-if="model&&model.approveStatus.desc == '已提交'"  icon="el-icon-share">待核验</el-link>
        <el-link type="success" class="el-link-css" :underline="false" v-if="model&&model.approveStatus.desc == '通过'" icon="el-icon-check">通过</el-link>
        <el-link type="danger"  class="el-link-css" :underline="false" v-if="model&&model.approveStatus.desc == '不通过'" icon="el-icon-close">不通过</el-link>
        <el-link type="warning" class="el-link-css" :underline="false" v-if="model&&model.approveStatus.desc == '废除'"  icon="el-icon-share">已改派</el-link>
    </div>
</template>
<script>
export default {
    name: 'approvalNodeStatus',
    props: { //用于封装组件的参数传递
        itemId:{//
            type:String,
            required: true
        }
    },
    data() {
      return {
          model:{},//审批备案项对象
          initDataFlag:false,//数据初始化完成标识
      }
    },
    methods: {
        getApprovalItem(){//获取核验备案项信息
            let params = new URLSearchParams();
            params.append("itemId",this.itemId);
            this.$ajax.get(process.env.API_HOST+"approval-record-history/getApprovalItem", {params:params}).then((res) => {
                if(res && res.status == 200) {
                    let resultData = res.data.data;
                    this.model = resultData;
                    this.$emit('getModel',this.model);
                    this.initDataFlag = true;
			    }
            })
        }
    },
    mounted(){
        this.getApprovalItem();

    }
}
</script>
<style scoped>
.el-link-span-css{
    font-size: 14px;
}
 .el-link-css{
     cursor:default;
     text-decoration:none;
     position: relative;
    display: contents;
 }
</style>



// WEBPACK FOOTER //
// src/components/approvalNodeStatus.vue